import { useTranslation } from 'react-i18next'

import { EmptyState } from '@/components/empty-state'
import { AtendimentoCard, AtendimentoCardSkeleton } from '@/features/atendimento/components/atendimento-card'
import { useSuspenseUltimosAtendimentos } from '@/features/atendimento/hooks/use-suspense-ultimos-atendimentos'
import { generateArrayIds } from '@/utils/array.utils'

export const ListaUltimosAtendimentos = () => {
  const { t } = useTranslation('atendimento')
  const { data: atendimentos } = useSuspenseUltimosAtendimentos()
  if (!atendimentos.length) {
    return (
      <EmptyState
        icon="blocks"
        title={t('components.empty_state.lista.titulo')}
        description={t('components.empty_state.lista.descricao')}
        className="h-126"
      />
    )
  }

  return (
    <div className="space-y-4">
      {atendimentos.map((atendimento) => (
        <AtendimentoCard key={atendimento.id} {...atendimento} />
      ))}
    </div>
  )
}

export const ListaUltimosAtendimentosSkeleton = () => {
  return (
    <div className="space-y-4">
      {generateArrayIds(5).map((id) => (
        <AtendimentoCardSkeleton key={id} />
      ))}
    </div>
  )
}
